import React from 'react';


const SectionScrollNavigator = ({ encounterID, activeID, setActiveID, hoveredItem, setHoveredItem, ...props }) => {
  let { defaultSelectedItems } = props; 
  let { historyofPresentIllness, reviewOfSystem, problems, currentMentalStatus, interventionsUsed, responseObservations, riskAssessment, prescriptions, supplements, vaccines, injections, labs, imaging, followUp, documents, additionalNotes } = defaultSelectedItems;
  const insertPosition = props?.customTemplateData?.[0]?.InsertPosition || '';
  
  const sections = [
    ...(insertPosition === 'Top' ? 
      [{  id: `ref-CF${encounterID}`, label: 'CT' }] : []
    ),
    { id: `ref-SUBJECTIVE-CC${encounterID}`, label: 'CC' },
    ...(historyofPresentIllness ? [{ id: `ref-SUBJECTIVE-HPI${encounterID}`, label: 'HPI' }] : []),
    ...(reviewOfSystem ? [{ id: `ref-SUBJECTIVE-ROS${encounterID}`, label: 'ROS' }] : []),
    ...(problems ? [{ id: `ref-ASSESSMENT-P${encounterID}`, label: 'P' }] : []),
    // { id: `ref-SUBJECTIVE-CC${encounterID}`, label: 'CC' },
    // { id: `ref-ASSESSMENT-P${encounterID}`, label: 'P' },
    {
      label: 'O',
      heading: `ref-OBJECTIVE${encounterID}`,
      children: [
    ...(currentMentalStatus ? [{ id: `ref-OBJECTIVE-CMS${encounterID}`, label: 'CMS' }] : []),
        // { id: `ref-OBJECTIVE-CMS${encounterID}`, label: 'CMS' },
        { id: `ref-OBJECTIVE-N${encounterID}`, label: 'N' },
      ],
    },
    {
      label: 'I',
      heading: `ref-INTERVENTION${encounterID}`,
      children: [
        { id: `ref-INTERVENTION-IN${encounterID}`, label: 'N' },
        ...(interventionsUsed ? [{ id: `ref-INTERVENTION-IU${encounterID}`, label: 'IU' }] : []),
        // { id: `ref-INTERVENTION-IU${encounterID}`, label: 'IU' },
      ],
    },
    {
      label: 'R',
      heading: `ref-RESPONSE${encounterID}`,
      children: [
        { id: `ref-RESPONSE-RN${encounterID}`, label: 'N' },
        ...(responseObservations ? [{ id: `ref-RESPONSE-RO${encounterID}`, label: 'RO' }] : []),
        // { id: `ref-RESPONSE-RO${encounterID}`, label: 'RO' },
      ],
    },
    {
      label: 'A',
      heading: `ref-ASSESSMENT${encounterID}`,
      children: [
        ...(riskAssessment ? [{ id: `ref-ASSESSMENT-RA${encounterID}`, label: 'RA' }] : []),
        // { id: `ref-ASSESSMENT-RA${encounterID}`, label: 'RA' },
        { id: `ref-ASSESSMENT-AN${encounterID}`, label: 'N' },
      ],
    },
    {
      label: 'P',
      heading: `ref-PLAN${encounterID}`,
      children: [
        ...(prescriptions ? [{ id: `ref-PLAN-Prescriptions${encounterID}`, label: 'P' }] : []),
        ...(supplements ? [{ id: `ref-PLAN-Supplements${encounterID}`, label: 'S' }] : []),
        ...(vaccines ? [{ id: `ref-PLAN-Vaccines${encounterID}`, label: 'V' }] : []),
        ...(injections ? [{ id: `ref-PLAN-Injections${encounterID}`, label: 'I' }] : []),
        ...(labs ? [{ id: `ref-PLAN-Labs${encounterID}`, label: 'L' }] : []),
        ...(imaging ? [{ id: `ref-PLAN-Imaging${encounterID}`, label: 'I' }] : []),

        { id: `ref-PLAN-N${encounterID}`, label: 'N' },
        
        ...(followUp ? [{ id: `ref-PLAN-FollowUp${encounterID}`, label: 'F' }] : []),
      ],
    },
    ...(insertPosition === 'Bottom' ? 
      [{  id: `ref-CF${encounterID}`, label: 'CT' }] : []
    ),
    ...(documents || additionalNotes) ?
    [{
      label: 'AI',
      heading: `ref-AdditionalINFO${encounterID}`,
      children: [
        ...(documents ? [{ id: `ref-AdditionalINFO-DOC${encounterID}`, label: 'DOC' }] : []),
        ...(additionalNotes ? [{ id: `ref-AdditionalINFO-N${encounterID}`, label: 'N' }] : []),
      ],
    }] : [],
    // {
    //   label: 'AI',
    //   heading: `ref-AdditionalINFO${encounterID}`,
    //   children: [
    //     { id: `ref-AdditionalINFO-DOC${encounterID}`, label: 'DOC' },
    //     { id: `ref-AdditionalINFO-N${encounterID}`, label: 'N' },
    //   ],
    // },
  ];
  const handleScrollIntoView = (id) => {
        setActiveID(id);
        setHoveredItem('');
    const element = document.getElementById(id);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        //onNavigate?.(id); // Optional callback
    }
  };

  return (
    <>
      {sections.map((section, index) => (
        <>
        <div className="d-flex flex-column gap-5" key={index}>
        {section?.children?.length > 0 ?
          (<>
            <p
              id={`vertical-bar-${section.id}`}
              className={`heading text-center ${
              section.children
                ? [section.id, ...section.children.map(c => c.id)].includes(activeID)
                  ? 'orange-drk'
                  : ''
                : activeID === section.id  ? 'orange-drk' : ''
            }`}
              onClick={() => handleScrollIntoView(section.heading)}
            >
              {section.label}
            </p>
            {section?.children?.map((child) => (
              <p
                key={child.id}
                id={`vertical-bar-${child.id}`}
                className={`box font-m text ar-light-color ${
                  activeID === child.id ? 'active' : ''
                } ${
                  hoveredItem === child.id ? 'active' : ''
                }`}
                onClick={() => handleScrollIntoView(child.id)}
              >
                {child.label}
              </p>
            ))}
          </>): 
          (<p
            key={section.id}
            id={`vertical-bar-${section.id}`}
            className={`box font-m text ar-light-color ${
              activeID === section.id ? 'active' : ''
            } ${
              hoveredItem === section.id ? 'active' : ''
            }`}
            onClick={() => handleScrollIntoView(section.id)}
          >
            {section.label}
          </p>)
          }
          </div>
        </>
      ))}
    </>
  );
};

export default SectionScrollNavigator;